import axios from "axios";
import Qs from "qs";

const BASE_URL = `${window.location.protocol}//${window.location.hostname}:8443/`;


const instance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    Authorization: `Bearer *token*`,
  },
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: "repeat" }),
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const publicAxios = axios.create({
  baseURL: `${BASE_URL}`,
  headers: { "Content-Type": "multipart/form-data" },
});

export { publicAxios, BASE_URL };

export default instance;
